var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-view',{attrs:{"GetOrderInfoToPay":_vm.GetOrderInfoToPay,"GetOrderPayFeeInfo":_vm.GetOrderPayFeeInfo,"PageOrderPay":_vm.PageOrderPay}})}
var staticRenderFns = []

export { render, staticRenderFns }